import React from "react";
import { TextField as MuiTextField } from "@mui/material";
import { Field } from "react-final-form";
import { ShowErrorFunc, showErrorOnChange } from "./Util";

const TextFieldWrapper = (props) => {
  const {
    input: { name, value, type, onChange, onBlur, onFocus, ...restInput },
    meta,
    required,
    fullWidth = true,
    helperText,
    showError = showErrorOnChange,
    ...rest
  } = props;
  const { error, submitError } = meta;
  const isError = showError({ meta });

  return (
    <MuiTextField
      fullWidth={fullWidth}
      helperText={isError ? error || submitError : helperText}
      error={isError}
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
      name={name}
      value={value}
      type={type}
      required={required}
      inputProps={{ required, ...restInput }}
      {...rest}
    />
  );
};

const TextField = (props) => {
  const { name, type, fieldProps, ...rest } = props;
  return (
    <Field
      name={name}
      type={type}
      render={({ input, meta }) => (
        <TextFieldWrapper
          input={input}
          meta={meta}
          name={name}
          type={type}
          {...rest}
        />
      )}
      {...fieldProps}
    />
  );
};
// const TextField = (props) => {
//   const {
//     name,
//     type,
//     label,
//     required,
//     variant,
//     disabled,
//     value,
//     ...restTextFieldProps
//   } = props;

//   return (
//     <Field
//       fullWidth
//       required={required}
//       variant={variant}
//       name={name}
//       type={type}
//       label={label}
//       disabled={disabled}
//       InputLabelProps={{
//         shrink: true,
//       }}
//       render={({ input, meta, ...restFieldProps }) => {
//         const fieldValue = input.value || value;
//         // console.log("input", input);
//         // console.log("meta", meta);
//         // console.log("restFieldProps", restFieldProps);
//         // console.log("restTextFieldProps", restTextFieldProps);
//         const isError = (meta.error || meta.submitError) && meta.touched;
//         return (
//           <MuiTextField
//             {...input}
//             {...restFieldProps}
//             error={isError}
//             helperText={isError ? meta.error : meta.submitError}
//             // value={fieldValue}
//             // {...restTextFieldProps}
//             // value={restTextFieldProps.defaultValue}
//             // value={input.value || restTextFieldProps.value}
//             // multiline={
//             //   restTextFieldProps.hasOwnProperty("multiline")
//             //     ? restTextFieldProps.multiline
//             //     : false
//             // }
//             // rows={
//             //   restTextFieldProps.hasOwnProperty("rows")
//             //     ? restTextFieldProps.rows
//             //     : 1
//             // }
//           />
//         );
//       }}
//     />
//   );
// };

export default TextField;
